import * as React from "react";
import classnames from "classnames";
/* empty css                 */
function CardSection({
  children,
  flex,
  flexContent,
  className,
  spacing = "l",
  ...rest
}) {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames("card-section", `card-section--spacing-${spacing}`, className, {
        "card-section--flex": flex,
        "card-section--flex-content": flexContent
      }),
      ...rest
    },
    children
  );
}
export {
  CardSection as default
};
//# sourceMappingURL=CardSection.js.map
